import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { UserAppService } from '../services/user-app.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SignUpGuard implements CanActivate {
  constructor(private userServices: UserAppService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.userServices.getRegistrationAllowedStatus().pipe(
      map((response: any) => {
        if (response.SIGN_UP_ALLOWED) {
          return true;
        } else {
          return false;
        }
      }),
      catchError((error: any) => {
        return of(false);
      })
    );
  }
}
